// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1681":"8dd3113548725b54","1698":"27de0b41b1f88f90","4896":"84f6640a228a67d3","5249":"25b0940c2fdd91e3","5259":"fc301960a33d88b1","8199":"f01407468f07465e"}[chunkId] + ".css";
};